import { RefObject, useEffect, useRef, useState } from "react";

export const useIsScrollingUp = (
    scrollableContainerRef?: RefObject<HTMLDivElement>,
) => {
    const [isScrollingUp, setIsScrollingUp] = useState(false);
    const lastScrollTop = useRef(0);

    useEffect(() => {
        const element = scrollableContainerRef?.current;
        const handleScroll = () => {
            const scrollTop = element?.scrollTop ?? window.scrollY;
            if (scrollTop > lastScrollTop.current) {
                setIsScrollingUp(false);
            } else if (scrollTop < lastScrollTop.current) {
                setIsScrollingUp(true);
            }
            lastScrollTop.current = Math.max(scrollTop, 0);
        };

        (element ?? window).addEventListener("scroll", handleScroll, {
            passive: true,
        });
        return () => {
            (element ?? window).removeEventListener("scroll", handleScroll);
        };
    }, [lastScrollTop.current, scrollableContainerRef?.current]);
    return isScrollingUp;
};
